import './UserIconMenu.scss'
import React, {useContext, useState} from "react";
import {I18nReactContext} from "../../contexts/I18nContext";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Logout from "@mui/icons-material/Logout";
import KeyIcon from '@mui/icons-material/Key';
import Menu from "@mui/material/Menu";
import {Link} from "react-router-dom";
import {Colors} from "../../Utils/styles/Colors";
import {UserReactContext} from "../../contexts/UserContext";


export const UserIconMenu = ({size}) => {
    const {i18n} = useContext(I18nReactContext);
    const userContext = useContext(UserReactContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const iconSize = size === 'small' ? 16 : 32;

    return (
        <div className="UserIconMenu">
            <Tooltip title={i18n.translate('UserIconMenu.settings')}
                     slotProps={{
                         popper: {
                             modifiers: [
                                 {
                                     name: 'offset',
                                     options: {
                                         offset: [0, -18],
                                     },
                                 },
                             ],
                         },
                     }}>
                <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <Avatar sx={{width: iconSize, height: iconSize, background: Colors['$menu-button-selected']}}/>
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                            mt: 1.5,
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1,
                            },
                        },
                    },
                }}
                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            >
                <MenuItem onClick={handleClose}>
                    <Link to="/logout" className="logoutLink">
                        <ListItemIcon>
                            <Logout fontSize="small"/>
                        </ListItemIcon>
                        {i18n.translate('menuItems.logout')}
                    </Link>
                </MenuItem>
                { userContext.isUserCompanyAdmin() || userContext.isUserSuperAdmin() ? <MenuItem onClick={handleClose}>
                    <Link to="/changePassword" className="changePasswordLink">
                        <ListItemIcon>
                            <KeyIcon fontSize="small"/>
                        </ListItemIcon>
                        {i18n.translate('menuItems.changePassword')}
                    </Link>
                </MenuItem> : ""}
            </Menu>
            {/*<Language fontSize="large"/>*/}
            {/*<div className="selectBoxWrapper">*/}
            {/*    <SelectBox options={languagesOptions} value={language}*/}
            {/*               onChange={onSelectedLanguage}/>*/}
            {/*</div>*/}
        </div>
    );
}